import {
  IAnimal,
  ICreateBatchOrFlock,
  IFilterAnimal,
} from "../../modules/animals/interface";
import { api } from "../api";

async function createAnimal(data: FormData) {
  await api.post("/animal", data);
}

async function updateAnimal(id: string, data: FormData) {
  return await api.put(`/animal/${id}`, data);
}

async function createBatch(data: ICreateBatchOrFlock) {
  await api.post("/animal/batch", data);
}

async function createFlock(data: ICreateBatchOrFlock) {
  await api.post("/animal/flock", data);
}

async function getAnimals({ id, page = 1, limit = 10 }: IFilterAnimal) {
  const url = `/animal/${id}?page=${page}&limit=${limit}`;

  const { data } = await api.get(url);

  return data;
}

async function allAnimals(id: string) {
  const animals: IAnimal[] = [];
  const page = 1;
  const limit = 1000;

  const url = `/animal/${id}?page=${page}&limit=${limit}`;

  const { data } = await api.get(url);

  animals.push(...data.data);

  if (data.meta.pages > 1) {
    for (let index = page + 1; index <= data.meta.pages; index++) {
      const url = `/animal/${id}?page=${page}&limit=${limit}`;

      const { data } = await api.get(url);
      animals.push(...data.data);
    }
  }

  return animals;
}

async function animalById(id: string) {
  const { data } = await api.get(`/animal/search/id/${id}`);

  return data;
}

async function historyAnimalById(id: string) {
  const { data } = await api.get(`/history/animal/${id}`);

  return data;
}

async function getAllFlocks(id: string) {
  const { data } = await api.get(`/animal/flock/farm/${id}`);

  return data;
}

async function getAllBatchs(id: string) {
  const { data } = await api.get(`/animal/batch/farm/${id}`);
  return data;
}

async function getAnimalsByBatch(id: string) {
  const { data } = await api.get(`/animal/batch/associate/${id}`);

  return data;
}

async function getAnimalsByFlock(id: string) {
  const { data } = await api.get(`/animal/flock/associate/${id}`);

  return data;
}

async function deleteAnimals(ids: string[]) {
  const { data } = await api.delete("/animal/removeAnimalsSelect", {
    data: {
      id: ids,
    },
  });

  return data;
}

async function deleteBatchs(ids: string[]) {
  const { data } = await api.post("/batch/remove/id", {
    batchs_id: ids,
  });

  return data;
}

async function deleteFlocks(ids: string[]) {
  const { data } = await api.post("/flock/remove/id", {
    flocks_id: ids,
  });

  return data;
}

async function moveAnimalsToOtherBatch(animalId: string, batchId: string) {
  const formData = new FormData();
  formData.append("batch", batchId);
  const { data } = await updateAnimal(animalId, formData);
  return data;
}

async function loadIntership() {
  const { data } = await api.get(`/animal/internship/language`, {
    params: {
      type: "milk,cut",
    },
  });
  return data;
}

async function loadBreed() {
  const { data } = await api.get(`/animal/breed/language`);
  return data;
}

async function loadLactation() {
  const { data } = await api.get(`/animal/lactation/language`);
  return data;
}
async function loadReproductiveStatus() {
  const { data } = await api.get(`/animal/reproductiveStatus/language`);
  return data;
}

export {
  createAnimal,
  updateAnimal,
  createBatch,
  createFlock,
  getAnimals,
  allAnimals,
  animalById,
  historyAnimalById,
  getAllBatchs,
  getAllFlocks,
  getAnimalsByBatch,
  getAnimalsByFlock,
  deleteAnimals,
  deleteBatchs,
  deleteFlocks,
  moveAnimalsToOtherBatch,
  loadIntership,
  loadBreed,
  loadLactation,
  loadReproductiveStatus,
};
